import React, { useEffect, useState } from 'react';
import { championsAPI } from '../api/api';

const Champions = () => {
  const [champions, setChampions] = useState([]);
  const [championsByOwner, setChampionsByOwner] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadChampions();
  }, []);

  const loadChampions = async () => {
    try {
      const [championsRes, byOwnerRes] = await Promise.all([
        championsAPI.getAll(),
        championsAPI.getByOwner()
      ]);
      
      setChampions(championsRes.data);
      setChampionsByOwner(byOwnerRes.data);
    } catch (error) {
      console.error('Error loading champions:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-96">
        <div className="text-2xl text-gray-600 dark:text-gray-400">Loading...</div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-8">🏆 Champions Hall of Fame</h1>

      {/* Championship Titles by Owner */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg dark:shadow-gray-900 p-6 mb-8">
        <h2 className="text-2xl font-bold mb-6 text-nba-blue">Championship Titles by Owner</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {championsByOwner.map((owner, index) => (
            <div
              key={index}
              className="bg-gradient-to-r from-yellow-400 to-yellow-600 rounded-lg p-6 text-white shadow-lg dark:shadow-gray-900"
            >
              <div className="text-4xl font-bold mb-2">{owner.titles}</div>
              <div className="text-xl font-semibold">{owner.ownerNickname}</div>
              <div className="text-sm opacity-90">
                {owner.titles === 1 ? 'Championship' : 'Championships'}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* All Champions */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg dark:shadow-gray-900 p-6">
        <h2 className="text-2xl font-bold mb-6 text-gray-800 dark:text-gray-200">All Championships</h2>
        <div className="space-y-6">
          {champions.map((champion, index) => (
            <div
              key={champion.id}
              className="border-l-4 border-yellow-500 bg-gray-50 dark:bg-gray-800 p-6 rounded-lg hover:shadow-md dark:shadow-gray-900 transition"
            >
              <div className="flex items-center justify-between flex-wrap">
                <div className="flex-1 min-w-0 mb-4 md:mb-0">
                  <div className="flex items-center mb-2">
                    <span className="text-3xl mr-3">🏆</span>
                    <div>
                      <h3 className="text-2xl font-bold text-gray-800 dark:text-gray-200">
                        {champion.team.city} {champion.team.name}
                      </h3>
                      <p className="text-gray-600 dark:text-gray-400">{champion.season.name}</p>
                    </div>
                  </div>
                  <div className="mt-3">
                    <span className="bg-nba-blue text-white px-4 py-2 rounded-full font-semibold">
                      Owner: {champion.ownerNickname}
                    </span>
                  </div>
                </div>
                {champion.finalScore && (
                  <div className="bg-white dark:bg-gray-800 px-6 py-4 rounded-lg shadow">
                    <div className="text-sm text-gray-600 dark:text-gray-400 mb-1">Finals Score</div>
                    <div className="text-2xl font-bold text-nba-blue">
                      {champion.finalScore}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {champions.length === 0 && (
          <div className="text-center py-12 text-gray-500 dark:text-gray-400">
            <p className="text-xl">No champions yet. Be the first to claim the title!</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Champions;
